import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { RevealAnnouncement } from 'components/dialogs/RevealAnnouncement';
import { FootballMarketSubscriptions } from 'routing/FootballMarketSubscriptions';

const FootballLayout = () => {
  const { currentUser } = useCurrentUserContext();
  const { forcedIntoOnboarding, footballUserProfile } = currentUser || {};
  if (forcedIntoOnboarding && !footballUserProfile?.commonGameOnboarded) {
    return <Outlet />;
  }
  return (
    <AppLayout>
      <FootballMarketSubscriptions />
      <RevealAnnouncement />

      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
      </Suspense>
    </AppLayout>
  );
};
export default FootballLayout;
